import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { Providers } from './app/providers';
import { queryClient } from './app/query-client';
import { router } from './app/router';
import { AuthProvider } from './features/auth/auth-context';
import { authAdapter } from './features/auth/memory-access-adapter';
import { i18n } from './i18n';
import './styles.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <I18nextProvider i18n={i18n}>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <Providers>
            <RouterProvider router={router} context={{ auth: authAdapter, queryClient }} />
          </Providers>
        </AuthProvider>
        {import.meta.env.DEV && <ReactQueryDevtools />}
      </QueryClientProvider>
    </I18nextProvider>
  </StrictMode>,
);
